export const OneSecond = 1000;
export const OneMinute = OneSecond * 60;
export const OneHour = OneMinute * 60;
export const OneDay = OneHour * 24;
